import { Pipe, PipeTransform } from '@angular/core';
import { concatenateObjectFields } from '@epicuro-next/utilities';
import { BasketRowProduct } from 'graphql-api/baskets-api-interfaces';
import { Product, SuggestProduct } from 'graphql-api/gql-api-interfaces';

type PipeProduct = Product | BasketRowProduct | SuggestProduct;

const defaultFieldsMap: Record<string, keyof PipeProduct> = {
  id: 'productId',
};

@Pipe({
  name: 'productTitle',
  standalone: false,
})
export class ProductTitlePipe implements PipeTransform {
  public transform(
    product: PipeProduct,
    {
      fields = [],
      separator = '-',
      fieldsMap = defaultFieldsMap,
    }: {
      fields?: string[];
      separator?: string;
      fieldsMap?: Record<string, keyof PipeProduct>;
    },
  ): string {
    return (
      concatenateObjectFields<PipeProduct>(
        separator,
        product,
        fields,
        fieldsMap,
      ) ||
      (product?.title ?? '')
    );
  }
}
